<div *ngIf="visiblePermanent; else disableSaving">

<div class="row py-5 mx-3 border-bottom border-top">

  <div *ngIf="shouldShowContributions" class="col-md-6 col-xl-3">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.contentIndex === 0" 
    [class.btn-outline-secondary]="contentLocation.contentIndex !== 0" (click)="switchTo(0)">
      Acumulados
    </button>
  </div>

  <div *ngIf="!shouldShowSavingsRegistration" class="mt-2 col-md-6 mt-md-0 col-xl-3 mt-xl-0">

    <div [matTooltip]="modificationDisabledReason" aria-label="mensaje" matTooltipPosition="above" [matTooltipDisabled]="shouldEnableSavingsModification">

      <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.contentIndex === 1" [class.btn-outline-secondary]="contentLocation.contentIndex !== 1"
       (click)="switchTo(1)" [disabled]="!shouldEnableSavingsModification" 
       [matBadgeHidden]="shouldEnableSavingsModification" matBadge="?" matBadgePosition="after" matBadgeColor="accent" matBadgeSize="large">
        Modificar Cuotas
      </button>

    </div>

  </div>

  <div class="mt-2 col-md-6 mt-md-2 col-xl-3 mt-xl-0">

    <div [matTooltip]="withdrawDisabledReason" aria-label="mensaje" matTooltipPosition="above" [matTooltipDisabled]="shouldEnableSavingsWithdraw">

      <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.contentIndex === 2" [class.btn-outline-secondary]="contentLocation.contentIndex !== 2" 
      (click)="switchTo(2)" [disabled]="!shouldEnableSavingsWithdraw" 
      [matBadgeHidden]="shouldEnableSavingsWithdraw" matBadge="?" matBadgePosition="after" matBadgeColor="accent" matBadgeSize="large">
        Retiros
      </button>

    </div>

  </div>

  <div *ngIf="!shouldShowSavingsRegistration" class="mt-2 col-md-6 mt-md-2 col-xl-3 mt-xl-0">

    <div [matTooltip]="cancellationDisabledReason" aria-label="mensaje" matTooltipPosition="above" [matTooltipDisabled]="shouldEnableSavingsCancellation">

      <button [ngClass]="'btn btn-block'" [class.btn-danger]="contentLocation.contentIndex === 3" [class.btn-outline-danger]="contentLocation.contentIndex !== 3" 
      (click)="switchTo(3)" [disabled]="!shouldEnableSavingsCancellation" [matBadgeHidden]="shouldEnableSavingsCancellation" matBadge="?" 
      matBadgePosition="after" matBadgeColor="accent" matBadgeSize="large">
        Cancelación
      </button>

    </div>

  </div>

  <div *ngIf="shouldShowSavingsRegistration" class="mt-2 col-md-6 mt-md-2 col-xl-3 mt-xl-0">

    <div [matTooltip]="reInscriptionDisabledReason" aria-label="mensaje" matTooltipPosition="above" [matTooltipDisabled]="shouldEnableSavingsRegistration">

      <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.contentIndex === 4" 
      [class.btn-outline-secondary]="contentLocation.contentIndex !== 4" (click)="switchTo(4)" 
      [disabled]="!shouldEnableSavingsRegistration" [matBadgeHidden]="shouldEnableSavingsRegistration" 
      matBadge="?" matBadgePosition="after" matBadgeColor="accent" matBadgeSize="large">
        Reinscripción
      </button>

    </div>


  </div>

</div>

<div class="row mt-3" *ngIf="contentLocation.contentIndex == 0 && shouldShowContributions">

  <div class="col-md-12">
    <app-ps-statement [contentLocation]="contentLocation"></app-ps-statement>
  </div>

</div>

<div class="row mt-3" *ngIf="contentLocation.contentIndex == 1">

  <div class="col-md-12">
    <app-ps-edit-registration [contentLocation]="contentLocation"></app-ps-edit-registration>
  </div>

</div>

<div class="row mt-3" *ngIf="contentLocation.contentIndex == 2">

  <div class="col-md-12">
    <app-ps-withdraw [contentLocation]="contentLocation"></app-ps-withdraw>
  </div>

</div>

<div class="row mt-3" *ngIf="contentLocation.contentIndex == 3">

  <div class="col-md-12">
    <app-ps-cancellation [contentLocation]="contentLocation"></app-ps-cancellation>
  </div>

</div>

<div class="row mt-3" *ngIf="contentLocation.contentIndex == 4">

  <div class="col-md-12">
    <app-ps-re-registration [contentLocation]="contentLocation"></app-ps-re-registration>
  </div>

</div>
</div>
<ng-template #disableSaving>
  <div class="row mt-4 mb-4">
    <div class="col-md-12 text-center noActions">
      <h5 class="mt-1">Caja de Ahorro Permanente</h5>
      <mat-icon aria-hidden="true">check</mat-icon>
      <h5> El detalle se encuentra deshabilitado. </h5>
    </div>
  </div>

</ng-template>